import {
  useCartContext
} from "@/context/cart"
import {
  CartPageFragment
} from "@/hooks/CartPage/cartPageFragments.gql.js"
import {
  MiniCartFragment
} from "@/hooks/MiniCart/miniCartFragments.gql"
import {
  gql,
  useMutation
} from "@apollo/client"


export const REMOVE_ITEM_MUTATION = gql`
    mutation RemoveItemForMiniCart($cartId: String!, $itemId: ID!) {
        removeItemFromCart(
            input: { cart_id: $cartId, cart_item_uid: $itemId }
        ) {
            cart {
                id
                ...MiniCartFragment
                ...CartPageFragment
            }
        }
    }
    ${MiniCartFragment}
    ${CartPageFragment}
`

export const useRemoveItem = () => {
  const [
    removeItem,
    {
      loading: removeItemLoading,
      called: removeItemCalled,
      error: removeItemError,
    },
  ] = useMutation(REMOVE_ITEM_MUTATION)

  const [{
    cartId 
  }] = useCartContext()


  const handleRemoveItem = async (id: string) => {
    try {
      await removeItem({
        variables: {
          cartId,
          itemId: id,
        },
      })

    } catch (e) {
      // Error is logged by apollo link - no need to double log.
    }
  }


  return {
    removeItemLoading,
    removeItemCalled,
    removeItemError,
    handleRemoveItem
  }
}
